import { Injectable, Inject } from '@angular/core';
import { QRCodeService } from './qr-code.service';
import { AuthService } from './auth.service';

@Injectable()
export class MenuService {

  private title: string;
  private subTitle: string;
  public visible: boolean;

  constructor(private qrCodeService: QRCodeService) {
    this.title = '';
    this.subTitle = '';
    this.visible = true;
  }

  isVisible(): boolean {
    return this.visible;
  }

  get currentTitle(): string {
    return this.title;
  }

  get currentSubTitle(): string {
    return this.subTitle;
  }

  get currentQrCode(): string {
    return this.qrCodeService.currentQrCode;
  }

  setMenuTitle(title: string, subTitle: string = ''): void {
    this.title = title;
    this.subTitle = subTitle;
    this.visible = true;
  }

  hideMenu(): void {
    this.visible = false;
  }
}
